module.exports = __webpack_public_path__ + "img/castle-L.f68c32c8.png";